/**
 * 禁用词相关API
 */
import http from './http'

export default class StopwordApi {
    // 启动单页检测
    static startSingle(params) {
        return http.httpPost('stopword/startSingle', params);
    }

    // 启动纯文字检测
    static startText(content) {
        return http.httpPost('stopword/startText', {content});
    }

    // 是否可以下载禁用词（文字）报告
    static canReportText(params) {
        return http.httpPost('stopword/canReportText', params);
    }

    static createReport(token) {
        return http.httpPost('stopword/createReport', {token});
    }

    static downloadXenuCSV(token) {
        return http.getBaseUrl() + '/toolkit/xenu/download?token=' + token;
    }

    static submitServiceForm(params) {
        return http.httpPost('serviceform', params);
    }

    static useVoucherCode(code) {
        return http.httpPost('/toolkit/useVoucher', {code});
    }

    // 获取纯文字检测累计数据
    static getAccumulative() {
        return http.httpGet('/stopword/accumulative');
    }

    // 下载纯文字检测word文档
    static downloadWord(id) {
        return http.getBaseUrl() + '/stopword/downloadWord?id=' + id;
    }
}



// WEBPACK FOOTER //
// ./app/api/stopword.api.js